import { PropsWithChildren } from 'react'

type RootProps = {}

export const Root = ({ children }: PropsWithChildren<RootProps>) => {
  return <div className="flex flex-row gap-4 bg-white">{children}</div>
}
